import {
  GET_CONTEXT_HUB,
  GET_CONTEXT_HUB_SUCCESS,
  GET_CONTEXT_HUB_FAILURE,
} from '../actions/contextHub';

const INITIAL_STATE = {
  loading: false,
  error: false,
  cached: false,
};

export default function contextHubReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_CONTEXT_HUB:
      return {
        ...state,
        cached: true,
        loading: true,
        error: false,
      };
    case GET_CONTEXT_HUB_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        contextHub: {
          ...state.contextHub,
          ...action.payload.accountContext,
          ...action.payload.indicatorContext,
        },
      };
    case GET_CONTEXT_HUB_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorContexts: action.payload && action.payload.errorContexts,
      };
    default:
      return state;
  }
}
